import { takeEvery, fork, put, all, call } from "redux-saga/effects"

import { createReferenceFailed, createReferenceSuccess, getAllReferencesFailed, getAllReferencesSuccess, updateReferenceFailed, updateReferenceSuccess, uploadRefFilesFailed, uploadRefFilesSuccess, viewRefFilesFailed, viewRefFilesSuccess, referenceDownloadFailed, referenceDownloadSuccess, deleteReferenceFileSuccess, deleteReferenceFileFail } from "./action"
import { CREATE_REFERENCE, GETALL_REFERENCES, UPDATE_REFERENCE, UPLOAD_REF_FILES, VIEW_REF_FILES, DOWNLOAD_REFERENCE, DELETE_REFERENCE_FILE_START } from "./ActionTypes"
import { createReferenceAPI, getAllReferencesAPI, updateReferenceAPI, uploadRefFilesAPI, viewRefFilesAPI, downloadReferenceAPI, deleteReferenceFileAPI } from "./api"

function* getAllReferencesAsync(action) {
  try {
    const response = yield call(getAllReferencesAPI, action.payload)
    if (response.status === 200) {
      yield put(getAllReferencesSuccess(response?.data?.data ? response?.data?.data : []))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(getAllReferencesFailed(error?.response?.data?.message || "Something Error Occured"))

  }
}

function* getAllReferences() {
  yield takeEvery(GETALL_REFERENCES, getAllReferencesAsync)
}


function* createReferenceAsync(action) {
  try {
    const response = yield call(createReferenceAPI, action.payload)
    if (response.status === 200) {
      yield put(createReferenceSuccess(response?.data?.message ? response?.data?.message : "Reference Created Successfully"))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(createReferenceFailed(error?.response?.data?.message || "Something Error Occured"))

  }
}

function* createReference() {
  yield takeEvery(CREATE_REFERENCE, createReferenceAsync)
}



function* updateReferenceAsync(action) {
  try {
    const response = yield call(updateReferenceAPI, action.payload)
    if (response.status === 200) {
      yield put(updateReferenceSuccess(response?.data?.message ? response?.data?.message : "Reference Updated Successfully"))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(updateReferenceFailed(error?.response?.data?.message || "Something Unexpected Error Occured"))

  }
}

function* updateReference() {
  yield takeEvery(UPDATE_REFERENCE, updateReferenceAsync)
}




function* viewRefFilesAsync(action) {
  try {
    const response = yield call(viewRefFilesAPI, action.payload)
    if (response.status === 200) {
      yield put(viewRefFilesSuccess(response?.data ? response?.data : []))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(viewRefFilesFailed(error?.response?.data?.message || "Something Unexpected Error Occured"))

  }
}

function* viewRefFiles() {
  yield takeEvery(VIEW_REF_FILES, viewRefFilesAsync)
}



function* uploadRefFilesAsync(action) {
  try {
    const response = yield call(uploadRefFilesAPI, action.payload)
    if (response.status === 200 || response.status === 201) {
      yield put(uploadRefFilesSuccess(response?.data?.message ? response?.data?.message : "Reference File Uploaded Successfully"))
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(uploadRefFilesFailed(error?.response?.data?.message || "Something Unexpected Error Occured"))

  }
}

function* uploadRefFiles() {
  yield takeEvery(UPLOAD_REF_FILES, uploadRefFilesAsync)
}

function* downloadReferenceAsync(action) {
  try {
    const response = yield call(downloadReferenceAPI, action.payload)

    if (response.status === 200) {
      // Create a blob and trigger browser download
      const blob = new Blob(
        [response.data],
        { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
      )

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "reference_master.xlsx")
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      yield put(
        referenceDownloadSuccess("Reference report downloaded successfully")
      )
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(
      referenceDownloadFailed(
        error?.response?.data?.message || "Something Unexpected Error Occured"
      )
    )
  }
}

function* downloadReference() {
  yield takeEvery(DOWNLOAD_REFERENCE, downloadReferenceAsync)
}

function* deleteReferenceFileAsync(action) {
  try {
    const response = yield call(deleteReferenceFileAPI, action.payload)

    if (response.status === 200) {
      yield put(
        deleteReferenceFileSuccess(
          response?.data?.message
            ? response.data.message
            : "File deleted successfully"
        )
      )
    } else {
      throw new Error(response)
    }
  } catch (error) {
    yield put(
      deleteReferenceFileFail(
        error?.response?.data?.message ||
          "Something Unexpected Error Occured"
      )
    )
  }
}

function* deleteReferenceFile() {
  yield takeEvery(
    DELETE_REFERENCE_FILE_START,
    deleteReferenceFileAsync
  )
}


function* ReferenceSaga() {
  yield all([
    fork(getAllReferences),
    fork(createReference),
    fork(updateReference),
    fork(viewRefFiles),
    fork(uploadRefFiles),
    fork(downloadReference),
    fork(deleteReferenceFile)
  ])
}

export default ReferenceSaga